module.exports = __webpack_public_path__ + "static/media/small-loader.a230c8ca.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/small-loader.gif
// module id = 29
// module chunks = 0